import ConstructionIcon from '@mui/icons-material/Construction'
import FlatwareIcon from '@mui/icons-material/Flatware'
import HotelIcon from '@mui/icons-material/Hotel'
import InsertDriveFileOutlined from '@mui/icons-material/InsertDriveFileOutlined'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import ScaleIcon from '@mui/icons-material/Scale'
import {
  IndustryFoodTypeEnum,
  IndustryTypeEnum,
} from '@ulysses-inc/harami_api_client'
import type { FunctionComponent, SVGProps } from 'react'
import LayoutScrollOneSvg from 'src/assets/icons/layout_scroll_1.svg?react'
import LayoutScrollTwoSvg from 'src/assets/icons/layout_scroll_2.svg?react'
import LayoutSlideSvg from 'src/assets/icons/layout_slide.svg?react'
import LayoutTableSvg from 'src/assets/icons/layout_table.svg?react'
import { IndustryNames } from 'src/features/templateEdit/onboarding/constants'
import type { IndustryInfo } from 'src/features/templateEdit/onboardingDynamic/types'

export const NewTemplateGroups: IndustryInfo[][] = [
  [
    {
      svgDescriptionComponent: [
        LayoutScrollOneSvg,
        LayoutScrollTwoSvg,
        LayoutSlideSvg,
      ],
      title: 'スクロール・紙芝居形式のひな形',
      type: IndustryFoodTypeEnum.EMPTY,
    },
    {
      svgDescriptionComponent: [LayoutTableSvg],
      title: '表形式のひな形',
      type: IndustryFoodTypeEnum.EMPTY,
    },
  ],
]

/**
 * 新規顧客向けのテンプレート選択肢。表形式を含まない。
 */
export const NewTemplateGroupsForNewCompany: IndustryInfo[][] = [
  [
    {
      svgComponent: InsertDriveFileOutlined as FunctionComponent<
        SVGProps<SVGSVGElement>
      >,
      title: '空のひな形からつくる',
      type: IndustryFoodTypeEnum.EMPTY,
    },
  ],
]

export const IndustryGroups: IndustryInfo[][] = [
  [
    {
      svgComponent: FlatwareIcon as FunctionComponent<SVGProps<SVGSVGElement>>,
      title: IndustryNames.FOOD,
      type: IndustryTypeEnum.FOOD,
    },
    {
      svgComponent: ScaleIcon as FunctionComponent<SVGProps<SVGSVGElement>>,
      title: IndustryNames.MANUFACTURE,
      type: IndustryTypeEnum.MANUFACTURE,
    },
    {
      svgComponent: HotelIcon as FunctionComponent<SVGProps<SVGSVGElement>>,
      title: IndustryNames.HOTEL,
      type: IndustryTypeEnum.HOTEL,
    },
    {
      svgComponent: LocalShippingIcon as FunctionComponent<
        SVGProps<SVGSVGElement>
      >,
      title: IndustryNames.LOGISTICS,
      type: IndustryTypeEnum.LOGISTICS,
    },
    {
      svgComponent: ConstructionIcon as FunctionComponent<
        SVGProps<SVGSVGElement>
      >,
      title: IndustryNames.MACHINE,
      type: IndustryTypeEnum.MACHINE,
    },
    {
      svgComponent: MoreHorizIcon as FunctionComponent<SVGProps<SVGSVGElement>>,
      title: IndustryNames.OTHER,
      type: IndustryTypeEnum.OTHER,
    },
    // NOTE: NDF のテンプレートは URL を直接指定した時のみ利用可能にしている
    // そのため、"テンプレートからつくる" には表示させないため
    // ここに NDF の設定は記載しない
  ],
]
